module.exports = __webpack_public_path__ + "static/media/comm_working@2x.54988408.png";